<template>
  <div class="order_bak2" v-portal>
    <div  class="kuang">
      <div class="top_title">
          <div>{{activetext==0?'文华会员登录':'积分兑换'}}</div>
          <div><img src="../../../assets/images/X_01.png" alt="" style="cursor:pointer" @click="close"></div>
      </div>
      <div class="center_text">
        <div class="login_text" v-if="activetext==0">
          <div class="input_border">
            <div><img src="../../../assets/images/ID_01.png" alt=""></div>
            <div><input type="text" class="input_btn" placeholder="请输入会员号/注册手机号" v-model="account"></div>
          </div>
          <div class="input_border">
            <div><img src="../../../assets/images/Key_01.png" alt=""></div>
            <div><input type="password" class="input_btn" placeholder="请输入账号密码" v-model="password"></div>
          </div>
          <div class="form_item1">
            <a href="https://cloudid.wenhua.com.cn/Home/WenhuaIDForgot" target="_blank" class="hre">忘记密码<img src="../../../assets/images/VT_01.png" alt="" style="transform: rotate(270deg);"></a>
          </div>
          <div class="login_btn" @click="Login">
              登录
          </div>
        </div>
        <div class="charge_text"  v-if="activetext==1">
          <div class="point_text">
            <div>会员号<span>{{$store.state.phone}}</span></div>
            <div>可用积分<span>{{$store.state.total}}</span></div>
            <div>本次订课消耗积分<span style="color:#ff8081">{{needPoint}}</span></div>
          </div>
          <div class="read_text">
            <img :src="ifRead?require('../../../assets/images/VC_01.png'):require('../../../assets/images/VC_02.png')" alt="" style="cursor:pointer;margin-top:-3px" @click="ifRead=!ifRead"><span>我已阅读并同意<span class="hre" @click="showRead=true">《模型编写视频教程》线上视频课订单</span>的全部内容</span>
          </div>
          <div class="login_btn" @click="chargepoint()">兑换</div>
        </div>
        <div class="charge_text"  v-if="activetext==2">
          <div class="point_text">
            <div>会员号<span>{{$store.state.phone}}</span></div>
            <div>可用积分<span>{{$store.state.total}}</span></div>
            <div>本次订课消耗积分<span style="color:#ff8081">{{needPoint}}</span></div>
          </div>
          <div class="warn_text">
            <img src="../../../assets/images/warn.png" alt="" style="cursor:pointer;margin-right:4px" @click="ifRead=!ifRead"><span>您的积分余额不足，无法兑换</span>
          </div>
          <div class="login_btn" @click="close()">退出</div>
        </div>
        <div class="success_text" v-if="activetext==3">
          <div class="red_text">兑换成功！</div>
          <div class="gray_text">您可在本页面听课，有效期自{{starDate}}至{{endDate}}期间听课次数不限。</div>
          <!-- <div class="gray_text">如需课程教材，请在下方填写邮寄地址;我们将在2个工作日内寄出。</div>
          <div class="suc_form" style="margin-bottom:10px">
            <div class="formitem"><label>姓名</label><input type="text" v-model="name"></div>
            <div class="formitem"><label>电话</label><input type="text" v-model="tel"></div>
            <div class="formitem">
              <label>省</label>
              <Selecter Placeholder="--" v-model="ProSelect" :SelectArr="Province" style="width:187px;height:40px" @change="setcity"></Selecter>
              <label>市</label>
              <Selecter Placeholder="--" v-model="CitySelect" :SelectArr="City" style="width:187px;height:40px"></Selecter></div>
            <div class="formitem" style="height:80px"><label>详细地址</label><textarea name="" id="" v-model="address"></textarea></div>
          </div>
          <div class="login_btn" style="letter-spacing:0" @click="submitform">
              确认提交
          </div> -->
        </div>
      </div>
    </div>
    <Loading v-if="showLoading" class="loading2"></Loading>
    <Text2 v-if="showRead" @textclose="showRead=false" :needPoint="needPoint" :course="course" ></Text2>
  </div>
</template>

<script>
import axios from 'axios'
import Loading from './Loading.vue'
import Text2 from './Text2.vue'
export default {
    data(){
      return{
        activetext:0,

        account:'',
        password:'',

        ifRead:false,
        showRead:false,
        exchangeid:'',

        Province:[],
        ProSelect:'',
        City:[],
        CitySelect:'',
        tel:'',
        address:'',
        name:'',
        startDate:'',
        endDate:'',

        showLoading:false,
      }
    },
    props:{
      needPoint:{
        type:Number,
        default:0
      },
      course:{
        type:Array,
        default:[]
      },
      ifcharge:{
        type:Boolean,
        default:true,
      },
      url:{
        type:String,
        default:'',
      }
    },
    components: {Loading,Text2},
    created(){
      if(!!this.$store.state.token){
        this.activetext=1
        this.$emit('resetList')
      }
    },
    methods:{
      returnMonth(x){
        return Number(x)+1
      },
      // submitform(){
      //   if(!this.name){
      //     this.wh8alert('请填写姓名')
      //     return
      //   }
      //   if(!this.tel){
      //     this.wh8alert('请填写电话')
      //     return
      //   }
      //   if(!this.ProSelect){
      //     this.wh8alert('请选择省份')
      //     return
      //   }
      //   if(!this.CitySelect){
      //     this.wh8alert('请选择城市')
      //     return
      //   }
      //   if(!this.address){
      //     this.wh8alert('请填写详细地址')
      //     return
      //   }

      //   axios({
      //       method: 'post',
      //       url: 'https://wt9.wenhua.com.cn/api/AddApi/SaveMemberExpress',
      //       headers:{
      //         'Authorization':this.$store.state.token,
      //       },
      //       data: {
      //         whid:this.$store.state.whid,
      //         name:this.name,
      //         phone:this.tel,
      //         type:1,
      //         province:this.ProSelect.text,
      //         city:this.CitySelect.text,
      //         address:this.address,
      //         exchangeid:this.exchangeid
      //       }
      //     }).then((res)=>{
      //       if(res.data.status){
      //         this.wh8alert(res.data.message)
      //         this.close()
      //       }
      //     })
        
      // },
      setcity(pro){
      axios.get('https://wh-api.wenhua.com.cn/api/OtherNeiWang/GetRegion',{params:{id:pro.value}}).then((res)=>{
      if(res.status){
        res.data.forEach((el,idx)=> {
          this.$set(this.City,idx,{value:el.id,text:el.name})
        });
      }
    })
    },
      close(){
        this.$emit('close')
      },
      chargepoint(){
        console.log(this.course)
        if(!this.ifRead){
          this.wh8alert('请确认我已阅读并同意《模型编写视频教程》线上视频课订单的全部内容') 
          return
        }
        if(Number(this.needPoint)>Number(this.$store.state.total)){
          this.activetext=2
        }
        else{
          this.showLoading=true
           axios({
            method: 'post',
            url: 'https://wt9.wenhua.com.cn/api/AddApi/MemberExchanged',
            headers:{
              'Authorization':this.$store.state.token,
            },
            data: {
              whid:this.$store.state.whid,
              product_subid:this.course.join(','),
            }
          }).then((res)=>{
            this.showLoading=false
            if(res.data.status){
              let day1 = new Date()
              this.starDate = day1.getFullYear()+'年' + this.returnMonth(day1.getMonth())+'月'+day1.getDate()+'日'
              day1.setFullYear(day1.getFullYear()+ 1);
              day1.setDate(day1.getDate()-1);
              this.endDate = day1.getFullYear()+'年' + this.returnMonth(day1.getMonth())+'月'+day1.getDate()+'日'
              this.$emit('resetList',true)
              this.activetext=3
              this.exchangeid = res.data.data.exchangeid
                axios.get('https://wh-api.wenhua.com.cn/api/OtherNeiWang/GetRegion').then((res)=>{
                if(res.status){
                  console.log(res.data)
                  res.data.forEach((el,idx)=> {
                    this.$set(this.Province,idx,{value:el.id,text:el.name})
                  });
                }
              })
            }
            else if(res.data.code==-405){
              this.wh8alert(res.data.message)
              setTimeout(()=>{this.$emit('close')},0)
            }
            else{
              this.activetext=2
            }
          })
        }
  
      },
      Login(){
          if(!this.account){
            this.wh8alert('请输入会员号/注册手机号')
            return 
          }
          if(!this.password){
            this.wh8alert('请输入账号密码')
            return 
          }
          this.showLoading=true
         axios({
            method: 'post',
            url: 'https://wt9.wenhua.com.cn/api/AddApi/Login',
            data:{
              whid:this.account,
              pwd:this.password,
            }
            }).then((res)=>{
              this.showLoading=false
              if(this.ifcharge){
                this.activetext=1;
              }
              if(res.data.status){
                this.$store.commit('setPhone',res.data.data.phone)
                this.$store.commit('setTotal',res.data.data.total)
                this.$store.commit('setWhid',res.data.data.whid)
                this.$store.commit('setToken',res.data.data.loginToken)
                if(!this.ifcharge){
                  this.$emit('resetList',true,this.url)
                  setTimeout(()=>{this.$emit('close')},0)
                }
                else{
                  console.log(2222222222)
                  this.$emit('resetList')
                }
                console.log(this.course)
                
                // this.activetext=1
              }
              else{
                this.wh8alert(res.data.message)
                setTimeout(()=>{this.$emit('close')},0)
              }
              
            })
      }
    },
    directives: {
    portal: {
      //自定义指令用于外层渲染
      inserted: function (el, binding) {
        var value = binding.value;
        console.log(binding);
        var app = document.querySelector("#app");
        try {
          if (value) {
            typeof value == "string"
              ? document.querySelector(value).appendChild(el)
              : value.appendChild(el);
          } else app.appendChild(el);
        } catch (error) {
          console.log(error);
        }
      },
    },
  },
}
</script>

<style scoped>
.order_bak2{
    position: fixed;
    background: rgba(0, 0, 0, 0.4);
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 8888;
}
.kuang{
  position: fixed;
  left: 50%;
  top: 35%;
  transform: translate(-50%, -50%);
  width: 375px;
  background: white;
  border-radius: 5px;
  text-align: justify;
}
.top_title{
  margin: 0 20px;
  padding: 15px 0;
  border-bottom: 1px solid #d3dbe8;
  font-size: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: #9299a3;
}
.login_text{
  width: 215px;
  margin: 0 auto;
  padding-top:10px ;
  padding-bottom: 20px;
}
.input_border{
  width: 215px;
  border: 1px solid #b3b3b3;
  border-radius: 5px;
  height: 36px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin: 10px 0;
}
.input_border:has(input:focus){
  border: 1px solid #73abfe;
}
.input_btn{
  outline: 0;
  border: none;
  margin-left: 5px;
}
.input_btn::placeholder{
  color: #b3b3b3;
  font-size: 15px;
}
.form_item1{
  height: 24px;
}
.form_item1 .hre{
  float: right;
  font-size: 14px;
}
.hre{
  color: #3988fe;
  cursor: pointer;
  text-decoration: none;
}
.hre:hover{
  text-decoration: underline;
}
.hre:visited{
  color: #3988fe;
}
.login_btn{
  width: 75px;
  background: #3889ff;
  height: 28px;
  line-height: 28px;
  text-align: center;
  border-radius: 4px;
  margin: 0 auto;
  color: white;
  font-size: 14px;
  letter-spacing: 5px;
  cursor: pointer;
}
.charge_text{
  width: 305px;
  margin: 0 auto;
  padding-bottom: 14px;
}
.point_text{
  padding: 20px 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  color: #999999;
  font-size: 14px;
  border-bottom: 1px solid #b2b2b2;
}
.point_text div{
  margin-right: 12px;
  padding: 3px 0;
}
.point_text span{
  color: #666666;
  margin-left: 8px;
}
.read_text{
  font-size: 12px;
  color: #666666;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-top: 7px;
}
.warn_text{
  font-size: 12px;
  color: #fe8083;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-top: 7px;
  margin-bottom: 10px;
}
.success_text{
  width: 300px;
  margin: 0 auto;
  padding: 20px 0;
  color: #666666;
}
.red_text{
  color: #d14246;
  font-size: 16px;
  font-weight: bold;
  line-height: 20px;
}
.gray_text{
  font-size: 16px;
  padding: 11px 0;
  line-height: 18px;
}
.suc_form .formitem{
  display: flex;
  flex-direction: row;
  height: 36px;
  padding:8px 0;
  align-items: center;
}
.formitem label{
  width: 2em;
  margin-right: 10px;
  text-align: right;
  flex-shrink: 0;
}
.formitem textarea{
  outline: 0;
  border: 1px solid #cccccc;
  border-radius: 4px;
  height: 100%;
  flex-grow: 1;
}
.formitem input{
  outline: 0;
  border: 1px solid #cccccc;
  border-radius: 4px;
  height: 100%;
  flex-grow: 1;
}
.formitem input:focus{
  border: 1px solid #73abfe;
}
</style>